// ------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template.
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
// ------------------------------------------------------------------------------

import { Dictionary } from '../../../shared/models/dictionary.model';
import { IBaseType } from '../../../shared/enums/ibase-type.enum';

export interface ICustomerIndividualMedicalAlertType {
    id: number;
    customerIndividualMedicalCategoryType: any;
    value: string;
    displayValue: string;
    description: string;
    suspensionDurationTypeId: number;
    suspensionDurationValue: number;
    isMedicalAlert: boolean;
    isMedicalCondition: boolean;
    isRequiredLastEpisodeDate: boolean;
    isRequiredOccurenceDate: boolean;
    isAdaptiveEquipment: boolean;
    sortOrder: number;
    active: boolean;
    code: string;
}

export class CustomerIndividualMedicalAlertType implements ICustomerIndividualMedicalAlertType, IBaseType {
    public id: number;
    public customerIndividualMedicalCategoryType: any;
    public value: string;
    public displayValue: string;
    public description: string;
    public suspensionDurationTypeId: number;
    public suspensionDurationValue: number;
    public isMedicalAlert: boolean;
    public isMedicalCondition: boolean;
    public isRequiredLastEpisodeDate: boolean;
    public isRequiredOccurenceDate: boolean;
    public isAdaptiveEquipment: boolean;
    public sortOrder: number;
    public active: boolean;
    public code: string;

    /**
		Returns Allergic to Antibiotics CustomerIndividualMedicalAlertType
	**/
    get AllergictoAntibiotics(): ICustomerIndividualMedicalAlertType {
        return this.FromId(1);
    }
    /**
		Returns Allergic to Aspirin CustomerIndividualMedicalAlertType
	**/
    get AllergictoAspirin(): ICustomerIndividualMedicalAlertType {
        return this.FromId(2);
    }
    /**
		Returns Allergic to Narcotics CustomerIndividualMedicalAlertType
	**/
    get AllergictoNarcotics(): ICustomerIndividualMedicalAlertType {
        return this.FromId(3);
    }
    /**
		Returns Allergic to Sulfa Drugs CustomerIndividualMedicalAlertType
	**/
    get AllergictoSulfaDrugs(): ICustomerIndividualMedicalAlertType {
        return this.FromId(4);
    }
    /**
		Returns Allergic to Tetanus Anti-toxin CustomerIndividualMedicalAlertType
	**/
    get AllergictoTetanusAntitoxin(): ICustomerIndividualMedicalAlertType {
        return this.FromId(5);
    }
    /**
		Returns Angina(Heart Pain) CustomerIndividualMedicalAlertType
	**/
    get AnginaHeartPain(): ICustomerIndividualMedicalAlertType {
        return this.FromId(6);
    }
    /**
		Returns Artificial Left Arm CustomerIndividualMedicalAlertType
	**/
    get ArtificialLeftArm(): ICustomerIndividualMedicalAlertType {
        return this.FromId(7);
    }
    /**
		Returns Artificial Right Arm CustomerIndividualMedicalAlertType
	**/
    get ArtificialRightArm(): ICustomerIndividualMedicalAlertType {
        return this.FromId(8);
    }
    /**
		Returns Artificial Left Leg CustomerIndividualMedicalAlertType
	**/
    get ArtificialLeftLeg(): ICustomerIndividualMedicalAlertType {
        return this.FromId(9);
    }
    /**
		Returns Artificial Right Leg CustomerIndividualMedicalAlertType
	**/
    get ArtificialRightLeg(): ICustomerIndividualMedicalAlertType {
        return this.FromId(10);
    }
    /**
		Returns Asthma CustomerIndividualMedicalAlertType
	**/
    get Asthma(): ICustomerIndividualMedicalAlertType {
        return this.FromId(11);
    }
    /**
		Returns Both Arms Artificial CustomerIndividualMedicalAlertType
	**/
    get BothArmsArtificial(): ICustomerIndividualMedicalAlertType {
        return this.FromId(12);
    }
    /**
		Returns Both Legs Artificial CustomerIndividualMedicalAlertType
	**/
    get BothLegsArtificial(): ICustomerIndividualMedicalAlertType {
        return this.FromId(13);
    }
    /**
		Returns Contact Lens CustomerIndividualMedicalAlertType
	**/
    get ContactLens(): ICustomerIndividualMedicalAlertType {
        return this.FromId(14);
    }
    /**
		Returns Diabetes/Insulin CustomerIndividualMedicalAlertType
	**/
    get DiabetesInsulin(): ICustomerIndividualMedicalAlertType {
        return this.FromId(15);
    }
    /**
		Returns Diabetes/Non-Insulin CustomerIndividualMedicalAlertType
	**/
    get DiabetesNonInsulin(): ICustomerIndividualMedicalAlertType {
        return this.FromId(16);
    }
    /**
		Returns Emphysema CustomerIndividualMedicalAlertType
	**/
    get Emphysema(): ICustomerIndividualMedicalAlertType {
        return this.FromId(17);
    }
    /**
		Returns Epilepsy CustomerIndividualMedicalAlertType
	**/
    get Epilepsy(): ICustomerIndividualMedicalAlertType {
        return this.FromId(18);
    }
    /**
		Returns Hearing Aid CustomerIndividualMedicalAlertType
	**/
    get HearingAid(): ICustomerIndividualMedicalAlertType {
        return this.FromId(19);
    }
    /**
		Returns Hearing Impaired CustomerIndividualMedicalAlertType
	**/
    get HearingImpaired(): ICustomerIndividualMedicalAlertType {
        return this.FromId(20);
    }
    /**
		Returns High Blood Pressure CustomerIndividualMedicalAlertType
	**/
    get HighBloodPressure(): ICustomerIndividualMedicalAlertType {
        return this.FromId(21);
    }
    /**
		Returns Pacemaker CustomerIndividualMedicalAlertType
	**/
    get Pacemaker(): ICustomerIndividualMedicalAlertType {
        return this.FromId(22);
    }
    /**
		Returns Paralyzed Left Side CustomerIndividualMedicalAlertType
	**/
    get ParalyzedLeftSide(): ICustomerIndividualMedicalAlertType {
        return this.FromId(23);
    }
    /**
		Returns Paralyzed Legs CustomerIndividualMedicalAlertType
	**/
    get ParalyzedLegs(): ICustomerIndividualMedicalAlertType {
        return this.FromId(24);
    }
    /**
		Returns Paralyzed Right Side CustomerIndividualMedicalAlertType
	**/
    get ParalyzedRightSide(): ICustomerIndividualMedicalAlertType {
        return this.FromId(25);
    }
    /**
		Returns Parkinson's Disease CustomerIndividualMedicalAlertType
	**/
    get ParkinsonsDisease(): ICustomerIndividualMedicalAlertType {
        return this.FromId(26);
    }
    /**
		Returns Narcolepsy CustomerIndividualMedicalAlertType
	**/
    get Narcolepsy(): ICustomerIndividualMedicalAlertType {
        return this.FromId(27);
    }
    /**
		Returns See Medical Card CustomerIndividualMedicalAlertType
	**/
    get SeeMedicalCard(): ICustomerIndividualMedicalAlertType {
        return this.FromId(28);
    }
    /**
		Returns Speech Impairment CustomerIndividualMedicalAlertType
	**/
    get SpeechImpairment(): ICustomerIndividualMedicalAlertType {
        return this.FromId(29);
    }
    /**
		Returns Alcohol / Drug Abuse CustomerIndividualMedicalAlertType
	**/
    get AlcoholDrugAbuse(): ICustomerIndividualMedicalAlertType {
        return this.FromId(30);
    }
    /**
		Returns Alzheimer's  CustomerIndividualMedicalAlertType
	**/
    get Alzheimers(): ICustomerIndividualMedicalAlertType {
        return this.FromId(31);
    }
    /**
		Returns Bipolar  CustomerIndividualMedicalAlertType
	**/
    get Bipolar(): ICustomerIndividualMedicalAlertType {
        return this.FromId(32);
    }
    /**
		Returns Cardiac Issue CustomerIndividualMedicalAlertType
	**/
    get CardiacIssue(): ICustomerIndividualMedicalAlertType {
        return this.FromId(33);
    }
    /**
		Returns Cognitive Issues  CustomerIndividualMedicalAlertType
	**/
    get CognitiveIssues(): ICustomerIndividualMedicalAlertType {
        return this.FromId(34);
    }
    /**
		Returns COPD CustomerIndividualMedicalAlertType
	**/
    get COPD(): ICustomerIndividualMedicalAlertType {
        return this.FromId(35);
    }
    /**
		Returns Dementia  CustomerIndividualMedicalAlertType
	**/
    get Dementia(): ICustomerIndividualMedicalAlertType {
        return this.FromId(36);
    }
    /**
		Returns Diabetic Event CustomerIndividualMedicalAlertType
	**/
    get DiabeticEvent(): ICustomerIndividualMedicalAlertType {
        return this.FromId(37);
    }
    /**
		Returns Hypertension CustomerIndividualMedicalAlertType
	**/
    get Hypertension(): ICustomerIndividualMedicalAlertType {
        return this.FromId(38);
    }
    /**
		Returns Limb Impairment  CustomerIndividualMedicalAlertType
	**/
    get LimbImpairment(): ICustomerIndividualMedicalAlertType {
        return this.FromId(39);
    }
    /**
		Returns Memory Loss CustomerIndividualMedicalAlertType
	**/
    get MemoryLoss(): ICustomerIndividualMedicalAlertType {
        return this.FromId(40);
    }
    /**
		Returns Neuropathy  CustomerIndividualMedicalAlertType
	**/
    get Neuropathy(): ICustomerIndividualMedicalAlertType {
        return this.FromId(41);
    }
    /**
		Returns Retinal Disease  CustomerIndividualMedicalAlertType
	**/
    get RetinalDisease(): ICustomerIndividualMedicalAlertType {
        return this.FromId(42);
    }
    /**
		Returns Schizophrenia  CustomerIndividualMedicalAlertType
	**/
    get Schizophrenia(): ICustomerIndividualMedicalAlertType {
        return this.FromId(43);
    }
    /**
		Returns Seizure  CustomerIndividualMedicalAlertType
	**/
    get Seizure(): ICustomerIndividualMedicalAlertType {
        return this.FromId(44);
    }
    /**
		Returns Sleep Apnea CustomerIndividualMedicalAlertType
	**/
    get SleepApnea(): ICustomerIndividualMedicalAlertType {
        return this.FromId(45);
    }
    /**
		Returns Stroke  CustomerIndividualMedicalAlertType
	**/
    get Stroke(): ICustomerIndividualMedicalAlertType {
        return this.FromId(46);
    }
    /**
		Returns Loss of Consciousness CustomerIndividualMedicalAlertType
	**/
    get LossofConsciousness(): ICustomerIndividualMedicalAlertType {
        return this.FromId(47);
    }
    /**
		Returns Traumatic Brain Injury (TBI) CustomerIndividualMedicalAlertType
	**/
    get TraumaticBrainInjuryTBI(): ICustomerIndividualMedicalAlertType {
        return this.FromId(48);
    }
    /**
		Returns Monocular Vision  CustomerIndividualMedicalAlertType
	**/
    get MonocularVision(): ICustomerIndividualMedicalAlertType {
        return this.FromId(49);
    }
    /**
		Returns Glaucoma  CustomerIndividualMedicalAlertType
	**/
    get Glaucoma(): ICustomerIndividualMedicalAlertType {
        return this.FromId(50);
    }
    /**
		Returns Cataracts  CustomerIndividualMedicalAlertType
	**/
    get Cataracts(): ICustomerIndividualMedicalAlertType {
        return this.FromId(51);
    }
    /**
		Returns Diabetic Retinopathy  CustomerIndividualMedicalAlertType
	**/
    get DiabeticRetinopathy(): ICustomerIndividualMedicalAlertType {
        return this.FromId(52);
    }
    /**
		Returns Nystagmus CustomerIndividualMedicalAlertType
	**/
    get Nystagmus(): ICustomerIndividualMedicalAlertType {
        return this.FromId(53);
    }
    /**
		Returns Color Blind CustomerIndividualMedicalAlertType
	**/
    get ColorBlind(): ICustomerIndividualMedicalAlertType {
        return this.FromId(54);
    }
    /**
		Returns Poor Night Vision CustomerIndividualMedicalAlertType
	**/
    get PoorNightVision(): ICustomerIndividualMedicalAlertType {
        return this.FromId(55);
    }
    /**
		Returns Biopic Telescopic Lens System CustomerIndividualMedicalAlertType
	**/
    get BiopicTelescopicLensSystem(): ICustomerIndividualMedicalAlertType {
        return this.FromId(56);
    }
    /**
		Returns Medical Condition General CustomerIndividualMedicalAlertType
	**/
    get MedicalConditionGeneral(): ICustomerIndividualMedicalAlertType {
        return this.FromId(57);
    }
    /**
		Returns Vision Condition General CustomerIndividualMedicalAlertType
	**/
    get VisionConditionGeneral(): ICustomerIndividualMedicalAlertType {
        return this.FromId(58);
    }

    private _dictionary: Dictionary = new Dictionary([]);

    constructor() {
        this._dictionary.add('1', { id: 1, customerIndividualMedicalCategoryType: null, value: 'AllergictoAntibiotics', displayValue: 'Allergic to Antibiotics', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '7C' });
        this._dictionary.add('2', { id: 2, customerIndividualMedicalCategoryType: null, value: 'AllergictoAspirin', displayValue: 'Allergic to Aspirin', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '7B' });
        this._dictionary.add('3', { id: 3, customerIndividualMedicalCategoryType: null, value: 'AllergictoNarcotics', displayValue: 'Allergic to Narcotics', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '7A' });
        this._dictionary.add('4', { id: 4, customerIndividualMedicalCategoryType: null, value: 'AllergictoSulfaDrugs', displayValue: 'Allergic to Sulfa Drugs', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '7E' });
        this._dictionary.add('5', { id: 5, customerIndividualMedicalCategoryType: null, value: 'AllergictoTetanusAnti-toxin', displayValue: 'Allergic to Tetanus Anti-toxin', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '7D' });
        this._dictionary.add('6', { id: 6, customerIndividualMedicalCategoryType: null, value: 'Angina(HeartPain)', displayValue: 'Angina(Heart Pain)', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '2C' });
        this._dictionary.add('7', { id: 7, customerIndividualMedicalCategoryType: null, value: 'ArtificialLeftArm', displayValue: 'Artificial Left Arm', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '6A' });
        this._dictionary.add('8', { id: 8, customerIndividualMedicalCategoryType: null, value: 'ArtificialRightArm', displayValue: 'Artificial Right Arm', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '6B' });
        this._dictionary.add('9', { id: 9, customerIndividualMedicalCategoryType: null, value: 'ArtificialLeftLeg', displayValue: 'Artificial Left Leg', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '6D' });
        this._dictionary.add('10', { id: 10, customerIndividualMedicalCategoryType: null, value: 'ArtificialRightLeg', displayValue: 'Artificial Right Leg', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '6E' });
        this._dictionary.add('11', { id: 11, customerIndividualMedicalCategoryType: null, value: 'Asthma', displayValue: 'Asthma', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '5A' });
        this._dictionary.add('12', { id: 12, customerIndividualMedicalCategoryType: null, value: 'BothArmsArtificial', displayValue: 'Both Arms Artificial', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '6C' });
        this._dictionary.add('13', { id: 13, customerIndividualMedicalCategoryType: null, value: 'BothLegsArtificial', displayValue: 'Both Legs Artificial', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '6F' });
        this._dictionary.add('14', { id: 14, customerIndividualMedicalCategoryType: null, value: 'ContactLens', displayValue: 'Contact Lens', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '6G' });
        this._dictionary.add('15', { id: 15, customerIndividualMedicalCategoryType: null, value: 'Diabetes/Insulin', displayValue: 'Diabetes/Insulin', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: true, isRequiredLastEpisodeDate: true, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '1A' });
        this._dictionary.add('16', { id: 16, customerIndividualMedicalCategoryType: null, value: 'Diabetes/Non-Insulin', displayValue: 'Diabetes/Non-Insulin', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: true, isRequiredLastEpisodeDate: true, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '1B' });
        this._dictionary.add('17', { id: 17, customerIndividualMedicalCategoryType: null, value: 'Emphysema', displayValue: 'Emphysema', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '5B' });
        this._dictionary.add('18', { id: 18, customerIndividualMedicalCategoryType: 1, value: 'Epilepsy', displayValue: 'Epilepsy', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 1, suspensionDurationValue: 90, isMedicalAlert: true, isMedicalCondition: true, isRequiredLastEpisodeDate: true, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '3A' });
        this._dictionary.add('19', { id: 19, customerIndividualMedicalCategoryType: null, value: 'HearingAid', displayValue: 'Hearing Aid', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '6H' });
        this._dictionary.add('20', { id: 20, customerIndividualMedicalCategoryType: null, value: 'HearingImpaired', displayValue: 'Hearing Impaired', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '4A' });
        this._dictionary.add('21', { id: 21, customerIndividualMedicalCategoryType: null, value: 'HighBloodPressure', displayValue: 'High Blood Pressure', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '2A' });
        this._dictionary.add('22', { id: 22, customerIndividualMedicalCategoryType: null, value: 'Pacemaker', displayValue: 'Pacemaker', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '2B' });
        this._dictionary.add('23', { id: 23, customerIndividualMedicalCategoryType: null, value: 'ParalyzedLeftSide', displayValue: 'Paralyzed Left Side', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: true, isAdaptiveEquipment: true, sortOrder: 999999, active: true, code: '8A' });
        this._dictionary.add('24', { id: 24, customerIndividualMedicalCategoryType: null, value: 'ParalyzedLegs', displayValue: 'Paralyzed Legs', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: true, isAdaptiveEquipment: true, sortOrder: 999999, active: true, code: '8C' });
        this._dictionary.add('25', { id: 25, customerIndividualMedicalCategoryType: null, value: 'ParalyzedRightSide', displayValue: 'Paralyzed Right Side', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: true, isAdaptiveEquipment: true, sortOrder: 999999, active: true, code: '8B' });
        this._dictionary.add('26', { id: 26, customerIndividualMedicalCategoryType: 1, value: 'Parkinson\'sDisease', displayValue: 'Parkinson\'s Disease', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '3C' });
        this._dictionary.add('27', { id: 27, customerIndividualMedicalCategoryType: 1, value: 'Narcolepsy', displayValue: 'Narcolepsy', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '3B' });
        this._dictionary.add('28', { id: 28, customerIndividualMedicalCategoryType: null, value: 'SeeMedicalCard', displayValue: 'See Medical Card', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '9A' });
        this._dictionary.add('29', { id: 29, customerIndividualMedicalCategoryType: null, value: 'SpeechImpairment', displayValue: 'Speech Impairment', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: true, isMedicalCondition: false, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '8D' });
        this._dictionary.add('30', { id: 30, customerIndividualMedicalCategoryType: 2, value: 'AlcoholDrugAbuse', displayValue: 'Alcohol / Drug Abuse', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 1, suspensionDurationValue: 90, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('31', { id: 31, customerIndividualMedicalCategoryType: 1, value: 'Alzheimer\'s', displayValue: 'Alzheimer\'s ', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('32', { id: 32, customerIndividualMedicalCategoryType: 1, value: 'Bipolar', displayValue: 'Bipolar ', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('33', { id: 33, customerIndividualMedicalCategoryType: 1, value: 'CardiacIssue', displayValue: 'Cardiac Issue', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('34', { id: 34, customerIndividualMedicalCategoryType: 1, value: 'CognitiveIssues', displayValue: 'Cognitive Issues ', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('35', { id: 35, customerIndividualMedicalCategoryType: 1, value: 'COPD', displayValue: 'COPD', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('36', { id: 36, customerIndividualMedicalCategoryType: 1, value: 'Dementia', displayValue: 'Dementia ', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('37', { id: 37, customerIndividualMedicalCategoryType: 1, value: 'DiabeticEvent', displayValue: 'Diabetic Event', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: true, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('38', { id: 38, customerIndividualMedicalCategoryType: 1, value: 'Hypertension', displayValue: 'Hypertension', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('39', { id: 39, customerIndividualMedicalCategoryType: 1, value: 'LimbImpairment', displayValue: 'Limb Impairment ', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: true, isAdaptiveEquipment: true, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('40', { id: 40, customerIndividualMedicalCategoryType: 1, value: 'MemoryLoss', displayValue: 'Memory Loss', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('41', { id: 41, customerIndividualMedicalCategoryType: 1, value: 'Neuropathy', displayValue: 'Neuropathy ', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('42', { id: 42, customerIndividualMedicalCategoryType: 1, value: 'RetinalDisease', displayValue: 'Retinal Disease ', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('43', { id: 43, customerIndividualMedicalCategoryType: 1, value: 'Schizophrenia', displayValue: 'Schizophrenia ', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('44', { id: 44, customerIndividualMedicalCategoryType: 1, value: 'Seizure', displayValue: 'Seizure ', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 1, suspensionDurationValue: 90, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: true, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('45', { id: 45, customerIndividualMedicalCategoryType: 1, value: 'SleepApnea', displayValue: 'Sleep Apnea', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('46', { id: 46, customerIndividualMedicalCategoryType: 1, value: 'Stroke', displayValue: 'Stroke ', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: true, isRequiredOccurenceDate: false, isAdaptiveEquipment: true, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('47', { id: 47, customerIndividualMedicalCategoryType: 1, value: 'LossofConsciousness', displayValue: 'Loss of Consciousness', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 1, suspensionDurationValue: 90, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: true, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('48', { id: 48, customerIndividualMedicalCategoryType: 1, value: 'TraumaticBrainInjury(TBI)', displayValue: 'Traumatic Brain Injury (TBI)', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: true, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('49', { id: 49, customerIndividualMedicalCategoryType: 3, value: 'MonocularVision', displayValue: 'Monocular Vision ', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('50', { id: 50, customerIndividualMedicalCategoryType: 3, value: 'Glaucoma', displayValue: 'Glaucoma ', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('51', { id: 51, customerIndividualMedicalCategoryType: 3, value: 'Cataracts', displayValue: 'Cataracts ', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('52', { id: 52, customerIndividualMedicalCategoryType: 3, value: 'DiabeticRetinopathy', displayValue: 'Diabetic Retinopathy ', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('53', { id: 53, customerIndividualMedicalCategoryType: 3, value: 'Nystagmus', displayValue: 'Nystagmus', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('54', { id: 54, customerIndividualMedicalCategoryType: 3, value: 'ColorBlind', displayValue: 'Color Blind', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('55', { id: 55, customerIndividualMedicalCategoryType: 3, value: 'PoorNightVision', displayValue: 'Poor Night Vision', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('56', { id: 56, customerIndividualMedicalCategoryType: 3, value: 'BiopicTelescopicLensSystem', displayValue: 'Biopic Telescopic Lens System', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('57', { id: 57, customerIndividualMedicalCategoryType: 1, value: 'MedicalConditionGeneral', displayValue: 'Medical Condition General', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
        this._dictionary.add('58', { id: 58, customerIndividualMedicalCategoryType: 3, value: 'VisionConditionGeneral', displayValue: 'Vision Condition General', description: 'Medical value to assist emergency units', suspensionDurationTypeId: 0, suspensionDurationValue: 0, isMedicalAlert: false, isMedicalCondition: true, isRequiredLastEpisodeDate: false, isRequiredOccurenceDate: false, isAdaptiveEquipment: false, sortOrder: 999999, active: true, code: '' });
    }

    public ToString(): string {
        return this.displayValue == null ? null : this.displayValue.toString();
    }

    public FromId(id: number): ICustomerIndividualMedicalAlertType {
        return this._dictionary[id];
    }

    public FromValue(value: string): ICustomerIndividualMedicalAlertType {
        var match = this._dictionary.getValues().filter(d => d.value == value);

        if (match.length > 0) {
            return this._dictionary[match[0].id];
        } else {
            return undefined;
        }
    }

    public GetAll(): ICustomerIndividualMedicalAlertType[] {
        return this._dictionary.getValues().sort(this.sort_by('sortOrder', false, null, this.sort_by('displayValue', false, null, null)));
    }

    public GetActive(): ICustomerIndividualMedicalAlertType[] {
        return this.GetAll().filter(d => d.active);
    }

    public Sort(primaryField, secondaryField, reverse): ICustomerIndividualMedicalAlertType[] {
        return this.GetAll().sort(this.sort_by(primaryField, reverse, null, secondaryField != null ? this.sort_by(secondaryField, reverse, null, null) : null));
    }

    private sort_by = (path, reverse, primer, then) => {
        var get = (obj, path) => {
                if (path) {
                    path = path.split('.');

                    for (var i = 0, len = path.length - 1; i < len; i++) {
                        obj = obj[path[i]];
                    }

                    return obj[path[len]];
                }
                return obj;
            },
            prime = (obj) => primer ? primer(get(obj, path)) : get(obj, path);

        return (a, b) => {
            var A = prime(a),
                B = prime(b);

            return (
                (A < B) ? -1 :
                    (A > B) ? 1 :
                        (typeof then === 'function') ? then(a, b) : 0
            ) * [1, -1][+!!reverse];
        };
    };
}
